import React, { useState, useEffect } from 'react';
import { ChevronUpIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../../contexts/ThemeContext';

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { actualTheme } = useTheme();

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-8 left-8 sm:left-1/2 sm:-translate-x-1/2 z-40">
          <button
            onClick={scrollToTop}
            className={`group relative px-6 py-3 rounded-full shadow-2xl transition-all duration-500 hover-magnify-sm modern-focus backdrop-blur-md border ${
              actualTheme === 'dark'
                ? 'bg-gradient-to-r from-slate-800/95 to-slate-700/95 border-slate-600/50 hover:from-slate-700/95 hover:to-slate-600/95 shadow-slate-900/30'
                : 'bg-gradient-to-r from-white/95 to-neutral-50/95 border-neutral-200/50 hover:from-white hover:to-neutral-100 shadow-neutral-900/20'
            }`}
            aria-label="Scroll to top"
            title="Scroll to top"
          >
            {/* Animated background glow */}
            <div className={`absolute inset-0 rounded-full transition-all duration-500 ${
              actualTheme === 'dark'
                ? 'bg-gradient-to-r from-primary-500/20 to-primary-600/20 opacity-0 group-hover:opacity-100'
                : 'bg-gradient-to-r from-primary-500/20 to-primary-600/20 opacity-0 group-hover:opacity-100'
            }`}></div>
            
            {/* Content */}
            <div className="relative flex items-center space-x-2">
              <ChevronUpIcon className={`h-5 w-5 transition-all duration-300 group-hover:scale-110 ${
                actualTheme === 'dark' ? 'text-slate-200' : 'text-neutral-700'
              }`} />
              <span className={`text-sm font-medium transition-all duration-300 ${
                actualTheme === 'dark' ? 'text-slate-200' : 'text-neutral-700'
              }`}>
                Back to Top
              </span>
            </div>
            
            {/* Pulse animation */}
            <div className={`absolute inset-0 rounded-full animate-pulse ${
              actualTheme === 'dark'
                ? 'bg-gradient-to-r from-primary-500/10 to-primary-600/10'
                : 'bg-gradient-to-r from-primary-500/10 to-primary-600/10'
            }`}></div>
          </button>
        </div>
      )}
    </>
  );
};

export default ScrollToTop;
